const VIDEO_PLAYERS = {
  YOUTUBE: 'youtube',
  JW_PLAYER: 'jw-player',
}

const IMAGE_PROVIDERS = {
  CLOUDINARY: 'cloudinary',
}

const IMAGE_WIDTH = {
  MOBILE_IMAGE_WIDTH: 1200,
  DESKTOP_IMAGE_WIDTH: 2500,
}

const IMAGE_MODERATION_STATUSES = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
}

export { VIDEO_PLAYERS, IMAGE_PROVIDERS, IMAGE_WIDTH, IMAGE_MODERATION_STATUSES }
